
<!-- close -->
<button type="button" class="close" aria-label="Close" (click)="close()" tabindex="-1">
  <span aria-hidden="true">&times;</span>
</button>

<app-loader *ngIf="loading"></app-loader>

<div class="page-modal" [ngClass]="galleryMode ? 'gallery-mode' : 'regular-mode'">

  <!-- old
  <div id="image-gallery" (click)="toggleGallery()" *ngIf="showGallery">
      <img src="{{ productImage?.modal?.img }}" />
  </div>
  -->

  <div class="row d-flex flex-row align-items-stretch" *ngIf="!loading && !showGallery" >

    <div class="col-md-5 _image">

      <!-- image -->
      <img hidden [src]="productImage?.modal?.img" class="image-check" alt="" (error)="onImageError('/assets/images/no-image-placeholder.png')">

      <!-- modal image -->
      <div *ngIf="imgUrl" class="photoframe" [appFlyToCart]="product?._id" cartSelector="cartbutton" source="modal" (click)="toggleGalleryMode()" [ngStyle]="{'background-image': 'url(' + imgUrl + ')'}" >
      </div>
      <div *ngIf="!imgUrl" class="photoframe" [appFlyToCart]="product?._id" cartSelector="cartbutton" source="modal" (click)="toggleGalleryMode()" [ngStyle]="{'background-image': 'url(' + productImage?.modal?.img + ')'}" >
      </div>

      <!-- more info link -->
      <p class="link" *ngIf="hasMoreInfoUrl && !galleryMode">
        <a [href]="product.moreInfoUrl" target="_blank">{{ 'catalog.view-detailed-specs' | translate }} <i class="fa fa-external-link"></i></a>
      </p>

      <!-- Download image link -->
      <p class="link" *ngIf="canDownloadImage">
        <a (click)="downloadImage(productImage?.modal?.img)">{{ 'catalog.download-image' | translate }} <i class="fa fa-external-link"></i></a>
      </p>

    </div>
    <div class="col-md-7 _text">

      <!-- text -->

      <div class="wrapper">

        <div class="favorite" [ngClass]="{'-active': isFavorite}">
            <a><i (click)="toggleFavorite($event)" class="fa" [ngClass]="{'fa-heart': isFavorite, 'fa-heart-o': !isFavorite}"></i></a>
        </div>

        <h3>{{ name }}</h3>

        <p class="productcode">
          {{ displayCode }}
        </p>

       <div *ngIf="hasPrice && canBuy">
          <p class="minquantity" *ngIf="prices && prices[0]?.minQuantity">
            {{ 'catalog.per-pieces' | translate: {count:  (prices && prices[0]?.minQuantity) } }}
          </p>

          <div class="page-modal_pricebox">

            <ul class="prices" *ngIf="hasMultiplePrices && prices?.length > 1">
              <li class="price" *ngFor="let price of prices | slice : 1; let index = index">
                <h6 *ngIf="hasMultiplePrices">
                  {{ 'catalog.price-from' | translate: {quantity: price?.minQuantity} }} {{ price.price | price:price.currency }}
                </h6>
              </li>
            </ul>

            <div class="row row-price-and-quantitypicker">
              <div class="col-md-3 col-sm-3 price">
                <span class="pricevalue"> {{ currentPrice.price | price:currentPrice.currency }} </span>
                <span class="legend">
                  {{ 'catalog.per-piece' | translate }}
                </span>
              </div>
              <div class="col-md-9 col-sm-9 quantity">

                <app-quantity-picker
                    *ngIf="canBuy && !showQuantityPickerAnimated"
                    [itemId]="product?._id"
                    source="modal"
                    [value]="actualQuantity"
                    [minQuantity]="minQuantity"
                    [stepping]="stepping"
                    [quantityType]="quantityPicker"
                    (quantityChanged)="quantityChanged($event)"
                >
                </app-quantity-picker>

                <app-quantity-picker-animated
                  *ngIf="canBuy && showQuantityPickerAnimated"
                  [itemId]="product?._id"
                  source="modal"
                  [value]="actualQuantity"
                  [alignment]="'flex-start'"
                  [minQuantity]="minQuantity"
                  [addButtonText]="'orders.addtocart' | translate"
                  (quantityChanged)="quantityChanged($event)"
                  [stepping]="stepping">
                </app-quantity-picker-animated>

              </div>
            </div>
          </div>
       </div>



        <div class="row row-details-and-stock">

          <!-- product eigenschappen -->
          <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12" *ngIf="showAdditionalProductDetails">

            <h4>{{ 'order.product-details' | translate }}</h4>

            <ul class="attributes-and-stock" *ngIf="showAttributes">
              <ng-container *ngFor="let productParam of product?.attrs">
                <ng-container *ngFor="let param of detailsPageSettings?.showAttributes">
                  <li *ngIf="productParam.key === param">
                    <span>{{ 'entity.label.product.attr.' + productParam.key | lowercase | translate }} </span>
                    <span class="attribute-stock-value text-right">{{ productParam.value }} </span>
                  </li>
                </ng-container>
              </ng-container>
            </ul>

            <div class="page-modal_attributes" *ngIf="showFacets">
              <ul class="attributes-and-stock" *ngIf="productFacets?.length">
                <ng-container *ngFor="let productFacet of productFacets">
                  <li>
                    <span>{{ productFacet?.name }} </span>
                    <span class="attribute-stock-value text-right">
                      <ng-container *ngFor="let value of productFacet?.values; let i = index; let last = last">
                        <ng-container *ngIf="value">
                          {{ last ? value : value + ', ' }}
                        </ng-container>
                      </ng-container>
                    </span>
                  </li>
                </ng-container>
              </ul>
            </div>

          </div> <!-- // end eigenschappen -->

          <!-- voorraad -->
          <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12" [ngClass]="detailsPageSettings?.showAttributes ? 'offset-xl-1' : ''"  *ngIf="filteredStockInfo?.length">

            <h4>{{ 'stock' | translate }}</h4>

            <ul class="attributes-and-stock">

              <ng-container *ngFor="let stockItem of filteredStockInfo">
                <li
                  *ngIf="stockItem?.type === 'current'">
                  <span>
                      {{ 'currentstock' | translate }}
                  </span>
                  <span class="attribute-stock-value text-right">
                    {{ stockItem?.quantity | numberFormat }}
                  </span>
                </li>

              <!-- Total in purchaseorders stock -->
                <li
                *ngIf="stockItem?.type === 'totalInPurchaseOrders'">
                <span>
                    {{ 'totalinpurchaseorderstock' | translate }}
                </span>
                <span class="attribute-stock-value text-right">
                    {{ totalInPurchaseOrderStock?.quantity | numberFormat }}
                </span>
                </li>

              <!-- Free stock -->
                <li
                  *ngIf="stockItem?.type === 'freeStock'">
                  <span>
                  {{ 'freestock' | translate }}
                  </span>
                  <span class="attribute-stock-value text-right">
                  {{ totalFreeStock?.quantity | numberFormat }}
                  </span>
              </li>

            <!-- Future stock -->
                <li
                  *ngIf="stockItem?.type === 'future'">
                  <span>
                      {{ 'expected' | translate }} {{ stockItem?.date | date: 'dd-MM-yyyy' }}
                  </span>
                  <span class="attribute-stock-value text-right">
                    {{ stockItem?.quantity | numberFormat }}
                  </span>
                </li>
              </ng-container>
            </ul>
          </div>

          <!--// end voorraad -->

          <!-- Backorders -->

          <div [ngClass]="{ 'col-xl-5': !detailsPageSettings?.showSalesOrderAddressInfo, 'col-xl-11': detailsPageSettings?.showSalesOrderAddressInfo }" class="col-lg-12 col-md-12 col-sm-12 backorders" *ngIf="selectedProductOrderHistory?.length || selectedProductBackorders?.length">

              <h4>{{ 'orders.previous-orders' | translate }}</h4>

              <div class="row row-heading">
                  <div class="col-md-7">
                    <span *ngIf="detailsPageSettings?.showSalesOrderAddressInfo">{{ 'checkout.address' | translate }}</span>
                    <span *ngIf="!detailsPageSettings?.showSalesOrderAddressInfo">{{ 'checkout.status' | translate }}</span>
                  </div>
                  <div class="col-md-3 text-right" *ngIf="showSalesOrderPriceInfo">{{ 'order.price' | translate }}</div>
                  <div [ngClass]="{ 'col-md-2': showSalesOrderPriceInfo, 'col-md-5': !showSalesOrderPriceInfo }" class="text-right">{{ 'order.quantity' | translate }}</div>
              </div>

              <ng-container *ngFor="let historyItem of selectedProductBackorders | orderBy: 'deliveryDate' : false">

                <div class="row" [ngClass]="{ 'margin-bottom-10': !detailsPageSettings?.showSalesOrderAddressInfo }">
                  <div class="col-md-7">
                    <!-- address -->
                    <ng-container *ngFor="let address of historyItem?.addresses">
                        <address *ngIf="(address.type | lowercase) === 'delivery'">
                            {{ address?.addressLine1 }}, {{ address?.city }}   <!-- {{ address?.country }} {{ address?.zipCode }}  {{ address?.name }} <br/> -->
                        </address>
                    </ng-container>

                    <!-- If no address available and showSalesOrderAddressInfo = false, show the deliverydate here -->
                    <span *ngIf="!detailsPageSettings?.showSalesOrderAddressInfo" class="row-expected">{{ 'product.expected-in-week' | translate: { week: historyItem?.deliveryDate | momentDateFormat: 'w' } }}</span>
                  </div>
                  <div class="col-md-3 text-right ordered-price" *ngIf="showSalesOrderPriceInfo">
                      {{ historyItem?.price | price: currency }}
                  </div>
                  <div [ngClass]="{ 'col-md-2': showSalesOrderPriceInfo, 'col-md-5': !showSalesOrderPriceInfo }" class="text-right quantity">
                      {{ historyItem?.quantityOutstanding | numberFormat }}
                  </div>
                </div>
                <div class="row row-expected" *ngIf="detailsPageSettings?.showSalesOrderAddressInfo">
                    <div class="col-md-12">{{ 'product.expected-in-week' | translate: { week: historyItem?.deliveryDate | momentDateFormat: 'w' } }}</div>
                </div>

              </ng-container>

             <ng-container *ngFor="let historyItem of selectedProductOrderHistory | orderBy: 'deliveryDate'; let i=index">
              <div *ngIf="i<3 || showMore">
                <div class="row" [ngClass]="{ 'margin-bottom-10': !detailsPageSettings?.showSalesOrderAddressInfo }">
                 <div class="col-md-7">
                   <!-- address -->
                   <ng-container *ngFor="let address of historyItem?.addresses">
                     <address *ngIf="(address.type | lowercase) === 'delivery'">
                       {{ address?.addressLine1 }}, {{ address?.city }}   <!-- {{ address?.country }} {{ address?.zipCode }}  {{ address?.name }} <br/> -->
                     </address>
                   </ng-container>

                  <!-- If no address available and showSalesOrderAddressInfo = false, show the deliverydate here -->
                  <span *ngIf="!detailsPageSettings?.showSalesOrderAddressInfo" class="row-delivered">{{ 'orders.delivered' | translate }} {{ historyItem?.deliveryDate | date: 'dd-MM-yyyy' }}</span>

                 </div>
                 <div class="col-md-3 text-right ordered-price" *ngIf="showSalesOrderPriceInfo">
                   {{ historyItem?.price | price: currency }}
                 </div>
                 <div [ngClass]="{ 'col-md-2': showSalesOrderPriceInfo, 'col-md-5': !showSalesOrderPriceInfo }" class="text-right quantity">
                   {{ historyItem?.quantityOrdered | numberFormat }}
                 </div>
               </div>
               <div class="row row-history row-delivered" *ngIf="detailsPageSettings?.showSalesOrderAddressInfo">
                 <div class="col-md-12">{{ 'orders.delivered' | translate }} {{ historyItem?.deliveryDate | date: 'dd-MM-yyyy' }}</div>
               </div>
              </div>
             </ng-container>

             <div *ngIf="selectedProductOrderHistory.length > 3">
                <a class="show-more" (click)="toggleShowMore()">
                  <span *ngIf="!showMore">{{ 'catalog.showmore' | translate }} <i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                  <span *ngIf="showMore">{{ 'catalog.showless' | translate }}  <i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                </a>
              </div>

          </div>

          <!-- End backorders -->

        </div>
      </div>
    </div>
  </div>
</div>

